<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import Author from '@/components/author/AuthorDetails.vue';
import ContentContainer from '@/components/layout/ContentContainer.vue';
import ContentColumn from '@/components/layout/ContentColumn.vue';
import type { Person } from '@/types';

defineProps<{
  person: Person;
}>();
</script>

<template>
  <ContentContainer class="person">
    <ContentColumn>
      <header class="personHeader">
        <Author
          :name="person.name"
          :title="person.title"
          :image="person.image"
          large
        />
        <NuxtLink
          v-if="typeof person.organisation === 'object'"
          :to="person.organisation.url"
          :target="person.organisation.target || '_self'"
        >
          {{ person.organisation.title }}
        </NuxtLink>
        <span v-else>{{ person.organisation }}</span>
      </header>

      <div
        v-if="person.bio"
        class="personBio"
      >
        <div v-html="person.bio" />
      </div>

      <div v-if="person.links?.length" class="personLinks">
        <NuxtLink
          v-for="(link, idx) in person.links"
          :key="idx"
          class="pageLink"
          :href="link.url"
          :target="link.target || '_self'"
        >
          {{ link.title }}
        </NuxtLink>
      </div>
    </ContentColumn>
  </ContentContainer>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.person {
  :deep(.column-main) {
    border-top: 0.1rem dotted var(--colour-warm-grey);
  }
  &:last-child {
    :deep(.column-main) {
      border-bottom: 0.1rem dotted var(--colour-warm-grey);
    }
  }
}
.personHeader {
  padding: var(--spacing-m) 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: var(--colour-mid-grey);
    font-size: 1.4rem;
  }

  @include screen.respond(tablet) {
    display: block;

    span {
      display: block;
      margin-top: var(--spacing-ms);
    }
  }
}
.personBio {
  margin-bottom: var(--spacing-ms);
}
.personLinks {
  margin: var(--spacing-ml) 0 var(--spacing-l);
}
</style>
